<template>
  <v-container-np>
    <v-main>
      <Snackbar
        :message="snackbarMessage"
        :show="showSnackbar"
        :hide-snackbar="hideSnackbarFunc"
        :type="snackbarType"
      ></Snackbar>
      <ActionDialog
        :type="actionDialogType"
        :title="actionDialogTitle"
        :show="showActionDialog"
        :isLoading="isActionLoading"
        :message="message"
        :on-action="actionFunction"
        :btn-text="actionText"
        :icon="iconName"
        :onHide="hideActionDialogFunc"
      >
      </ActionDialog>
      <slot />
    </v-main>
  </v-container-np>
</template>
<script lang="ts" setup>
import getActionDialogLogic from "~/composables/common/action_dialog_logic";
import getSnackBarLogic from "~/composables/common/snackbar_logic";
import { actionDialogKey, snackbarKey } from "~/core/keys";

const {
  hideSnackbarFunc,
  showSnackbar,
  showSnackbarFunc,
  snackbarType,
  snackbarMessage,
} = getSnackBarLogic();
provide(snackbarKey, { showSnackbarFunc, hideSnackbarFunc });

const {
  dialogType: actionDialogType,
  hideActionDialogFunc,
  showActionDialog,
  showActionDialogFunc,
  title: actionDialogTitle,
  isActionLoading,
  actionFunction,
  message,
  iconName,
  showMessageDialogFunc,
  actionText,
  setIsActionLoading,
} = getActionDialogLogic();

provide(actionDialogKey, {
  showActionDialogFunc,
  showMessageDialogFunc,
  hideActionDialogFunc,
  setIsActionLoading,
});
</script>
